import { useFlags } from '@mint-lib/routing-context';

import { usePlanningSocket } from '../../hooks/sockets/usePlanningSocket.js';
import { usePlanningSocketLegacy } from '../../hooks/sockets/usePlanningSocketLegacy.js';

const PlanningSocketNew = () => {
  usePlanningSocket();

  return null;
};

const PlanningSocketLegacy = () => {
  usePlanningSocketLegacy();

  return null;
};

const PlanningSocketRunner = () => {
  const ff = useFlags('@mint/arm', ['fixRoomJoin']);

  return ff.fixRoomJoin.enabled ? (
    <PlanningSocketNew />
  ) : (
    <PlanningSocketLegacy />
  );
};

export default PlanningSocketRunner;
